<div class="card">
    <div class="card-header">
        <b>SIRIIAGRO</b>
    </div>
</div>

<div class="card">
    <div class="card-body card-home">
        <div class="home-page">
            <div class="login-logo">
                <img
                    src="assets/images/logo-SiriiagroV1.svg"
                    alt="logo de Sirriiagro"
                    class="home-logo" />
            </div>
            <div class="parrafo-inicio">
                <p style="display: none">Version 1.0.0</p>
            </div>
            <div class="instructivo">
                Esta aplicación funciona mejor con Mozilla Firefox y Google
                Chrome
            </div>
        </div>
    </div>
</div>
